import { Button, Form, Input, Modal, Table } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import { CloseOutlined } from "@ant-design/icons";
import { apiGetPath, apiPost } from "../../api/api";
import { isEmpty } from "../../utils/comm";
import "./admin.css";
const EditableContext = React.createContext(null);

let saveConfirmPop = false;
let zoneNameConfirmPop = false;
let delDataSource = [];

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    let nullVal = JSON.parse('{"znNm":""}');

    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      toggleEdit();
      handleSave({ ...record, nullVal });
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title}은 필수입력입니다.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className='editable-cell-value-wrap'
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

function PopManageArea({ children }) {
  const [dataSource, setDataSource] = useState();
  const [count, setCount] = useState(1);
  const [formArea] = Form.useForm();

  // [SVC-0105024001] 구역목록 조회
  const apiGetZones = async () => {
    const response = await apiGetPath(`Zones/list/${children.siteId}`);
    try {
      if (response.code === 0) {
        setDataSource(response.data);
      } else if (response.code === 10) {
        setDataSource([]);
      }
    } catch (error) {}
  };
  useEffect(() => {
    delDataSource.length = 0;
    apiGetZones();
    setCount(1);
  }, [children]);

  const onFinishProc = () => {
    onFinishUpdate();
    onFinishInsert();
    onFinishDelete();
  };

  // [SVC-0105021001] 구역정보 수정
  const onFinishUpdate = async () => {
    let znNmNull = null;
    if (isEmpty(dataSource)) {
      return;
    }

    znNmNull = dataSource.find((item, index, data) => {
      return isEmpty(item.znNm);
    });

    if (!isEmpty(znNmNull)) {
      zoneNameConfirm();
      return;
    }

    let param = dataSource.filter((item) => item.newYn !== "Y");

    if (isEmpty(param)) {
      return;
    }

    const param2 = param.map((item) => ({
      siteId: item.siteId,
      znNm: item.znNm,
      zoneTp: item.zoneTp,
      znId: item.znId,
      svcId: item.svcId,
      delYn: "N",
    }));
    const response = await apiPost("Zones/", param2);
    try {
      if (response.data.code === 0 || response.data.code === 2) {
        saveConfirm();
      }
    } catch (error) {}
  };

  // [SVC- 0105021001] 구역정보 추가
  const onFinishInsert = async () => {
    let znNmNull = null;

    if (isEmpty(dataSource)) {
      return;
    }

    znNmNull = dataSource.find((item, index, data) => {
      return isEmpty(item.znNm);
    });

    if (!isEmpty(znNmNull)) {
      zoneNameConfirm();
      return;
    }

    let param = dataSource.filter((item) => item.newYn === "Y");

    if (isEmpty(param)) {
      return;
    }
    const param2 = param.map((item) => ({
      siteId: item.siteId,
      znNm: item.znNm,
      zoneTp: item.zoneTp,
      znId: null,
      svcId: item.svcId,
      delYn: "N",
    }));
    const response = await apiPost(`Zones/`, param2);
    try {
      saveConfirm();
      await apiGetZones();
    } catch (error) {}
  };

  // [SVC- 0105021001] 구역정보 삭제
  const onFinishDelete = async () => {
    if (delDataSource.length == 0) {
      return;
    }

    // PUT Zones API는 사용 불가, Post Zones에 delYn값을 이용하여 삭제 처리
    const response = await apiPost(`Zones/`, delDataSource);
    try {
      if (response.data.code === 0) {
        saveConfirm();
      }
    } catch (error) {}
  };

  function zoneNameConfirm() {
    if (zoneNameConfirmPop) {
      return;
    }

    zoneNameConfirmPop = true;

    Modal.confirm({
      title: "구역명 확인",
      icon: null,
      content: "구역명은 필수입력입니다.",
      okText: "확인",
      onOk: () => (zoneNameConfirmPop = false),
      centered: true,
      cancelButtonProps: { style: { display: "none" } },
    });
  }

  function saveConfirm() {
    if (saveConfirmPop) {
      return;
    }

    saveConfirmPop = true;
    Modal.confirm({
      title: "저장 완료",
      icon: null,
      content: "저장이 완료 되었습니다.",
      okText: "확인",
      onOk: () => (saveConfirmPop = false),
      centered: true,
      cancelButtonProps: { style: { display: "none" } },
    });
  }

  function confirm(recode, index) {
    Modal.confirm({
      title: "구역삭제",
      icon: null,
      content: "삭제하시겠습니까?",
      okText: "예",
      cancelText: "아니오",
      centered: true,
      onOk: () => delZone(recode, index),
    });
  }

  // [SVC-0105022001] 구역정보 삭제
  const delZone = (recode, index) => {
    const rows = [...dataSource];
    const param = {
      siteId: recode.siteId,
      znNm: recode.znNm,
      zoneTp: recode.zoneTp,
      svcId: recode.svcId,
      znId: recode.znId,
      delYn: "Y",
    };

    if (isEmpty(recode.newYn)) {
      delDataSource.push(param);
    }

    rows.splice(index, 1);
    setDataSource([...rows]);
  };

  const defaultColumns = [
    {
      title: "No",
      dataIndex: "",
      render: (_, record, index) => index + 1,
    },
    {
      title: "구역명",
      dataIndex: "znNm",
      width: "50%",
      editable: true,
    },
    {
      title: "등록일",
      dataIndex: "createDt",
    },
    {
      title: "",
      dataIndex: "znId",
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <Button
            icon={<CloseOutlined />}
            size='small'
            className='btn-ico-del'
            onClick={() => confirm(record, index)}
          />
        ) : null,
    },
  ];

  const handleAdd = () => {
    const newData = {
      siteId: children.siteId,
      znId: `${count}`,
      znNm: ``,
      svcId: children.svcId,
      zoneTp: `ZNP00010`,
      createDt: moment().format("YYYY-MM-DD"),
      codeNm: `codeNm`,
      newYn: `Y`,
    };
    if (dataSource === null) {
      setDataSource([newData]);
    } else {
      setDataSource([...dataSource, newData]);
    }
    setCount(count + 1);
  };

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.znId === item.znId);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <div>
      <Button
        // onClick={saveConfirm}
        onClick={handleAdd}
        type='primary'
        style={{
          marginBottom: 16,
        }}
      >
        구역추가
      </Button>
      <Form form={formArea} onFinish={onFinishProc} id='formArea'>
        <Table
          components={components}
          rowClassName={() => "editable-row"}
          bordered
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </Form>
    </div>
  );
}

export default PopManageArea;
